import { ListFilterScreenProps } from "./useFilters";
import { ImageQualityRating } from "gql/generated";
import { useTranslation } from "react-i18next";
import { Checklist } from "shared/components";

export const MediaQualityFilter = ({
  filters,
  onUpdateFilters,
}: ListFilterScreenProps) => {
  const { t } = useTranslation();

  const formattedMediaQualityData = Object.values([
    ImageQualityRating.Low,
    ImageQualityRating.Average,
    ImageQualityRating.High,
  ]).map((quality) => ({
    label: t(`core:LOOKUPS.OPERATOR_AVG_IMAGE_QUALITY.${quality}`),
    value: quality,
  }));
  const selectedMediaQuality = filters.mediaQuality;

  const handleMediaQualitySelect = (qualities: string[]) => {
    onUpdateFilters({
      mediaQuality: qualities as ImageQualityRating[],
    });
  };
  return (
    <Checklist
      data={formattedMediaQualityData}
      onValueChange={handleMediaQualitySelect}
      value={selectedMediaQuality}
    />
  );
};
